<template>
  <div>
    <h1 style="text-decoration: underline">{{ schema.name }} - Kanban </h1>
    <v-layout row style="margin-top:2rem" wrap>
      <v-flex xs12>
        <v-text-field v-model="template" color="primary" label="Szablon nazwy"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-select v-model="field" :items="fields" item-text="name" item-value="value" label="Pole kanban"></v-select>
      </v-flex>
      <v-btn @click="save()">Zapisz</v-btn>
    </v-layout>
  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import FieldType from "@/enums/fieldType"

export default {
  data() {
    return {
      field: null,
      template: "",
      schema: {}
    }
  },
  created() {
    this.$http.get(`schema/${this.$route.params.schemaId}`).then(data => {
      this.schema = data.data
    }).catch(() => {
      Messenger.emitError("Bład!")
    })
  },
  methods: {
    save() {
      this.$http.post('kanban', this.getData()).then(data => {
        this.$router.push('/form/' + data.data.schema_id)
      }).catch(() => {
        Messenger.emitError("Błąd podczas tworzenia!")
      })
    },
    getData() {
      return {
        'schema_id': Number(this.$route.params.schemaId),
        'field_id': this.field,
        'name_template': this.template
      }
    }
  },
  computed: {
    fields() {
      if (!this.schema.fields) {
        return []
      }

      return this.schema.fields
          .filter(el => el.type == FieldType.RADIO)
          .map(field => ({name: field.name, value: field.id}))
    }
  }
}
</script>


<style scoped>

</style>